// src/components/ProductCard.js

import React from 'react';

const ProductCard = ({ product, onDownloadClick, onImageClick }) => {
  // --- CONDITIONS to check if the data exists and is not empty ---
  const hasDownload = product.pdfUrl && product.pdfUrl.trim() !== '' && product.pdfUrl.trim() !== '#';
  const hasTitle = product.title && product.title.trim() !== '';
  const hasDescription = product.description && product.description.trim() !== '';

  return (
    <div className="product-card" onClick={() => onImageClick(product.imageUrl)}>
      <img
        src={product.imageUrl}
        // MODIFIED: Added a fallback alt tag for better accessibility
        alt={hasTitle ? product.title : 'Product Image'}
        className="product-card-image"
        loading="lazy"
      />
      
      <div className="card-content-overlay">
        {/* The top content will only render if there's a title or description */}
        {(hasTitle || hasDescription) && (
            <div className="card-top-content">
                {/* MODIFIED: Only show the h3 if a title exists */}
                {hasTitle && <h3 className="card-title">{product.title}</h3>}
                
                {/* MODIFIED: Only show the p if a description exists */}
                {hasDescription && <p className="card-description">{product.description}</p>}
            </div>
        )}
        <div className="card-bottom-content">
          <div className="card-tags">
            {product.tags.map((tag) => (
              <span key={tag} className="card-tag">
                {tag}
              </span>
            ))}
          </div>

          {/* This conditional rendering is unchanged and correct */}
          {hasDownload && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDownloadClick(product);
              }}
              className="card-download-btn"
            >
              Download Specs
            </button>
          )}

        </div>
      </div>
    </div>
  );
};

export default ProductCard;